const style = (theme) => ({
  formContainer: {
    maxHeight: '60vh',
    padding: theme.spacing(2.5, 2, 2),
  },
})

export default style
